// extracted by mini-css-extract-plugin
export var addButton = "_53-d";
export var bullets = "_53-e";
export var compact = "_53-2";
export var container = "_53-j";
export var extendedWarrantyModal = "_53-f";
export var learn = "_53-l";
export var learnMore = "_53-g";
export var offeringOption = "_53-3";
export var offeringPrice = "_53-8";
export var offeringSubtitle = "_53-7";
export var offeringTitle = "_53-6";
export var offeringsContainer = "_53-0";
export var pdpTilesBackground = "_53-n";
export var plan = "_53-m";
export var regular = "_53-1";
export var remove = "_53-k";
export var seeDetailsIcon = "_53-i";
export var seeDetailsLink = "_53-h";
export var selectedOption = "_53-4";
export var shieldIcon = "_53-b";
export var shieldIconCompact = "_53-c";
export var subtitle = "_53-a";
export var title = "_53-9";
export var unselectedOption = "_53-5";